import { FeatureDcExtended, SelectedFeatureDc } from "./types";

export const isSelectedFeature = (feature: unknown): feature is SelectedFeatureDc =>
  typeof feature === "object" && feature !== null && "layerDefinition" in feature;

export const featureId = ({ id }: Pick<FeatureDcExtended, "id">) => id;

export const getNewCurrentId = (
  features: FeatureDcExtended[],
  newFeatures: FeatureDcExtended[],
  prevId: string,
): string | null => {
  if (newFeatures?.some(feature => featureId(feature) === prevId)) {
    return prevId;
  }

  if (prevId) {
    const prevIdIndex = features?.findIndex(feature => featureId(feature) === prevId);
    const currentFeature =
      newFeatures.length - 1 > prevIdIndex ? newFeatures[prevIdIndex] : newFeatures[newFeatures.length - 1];

    return (currentFeature?.id && featureId(currentFeature)) || null;
  }

  return (newFeatures?.[0]?.id && featureId(newFeatures?.[0])) || null;
};
